"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FeaturedList;

var _preact = require("preact"); // eslint-disable no-shadowed-variable
// eslint-disable no-console


var handleEmptyComponent = function handleEmptyComponent(emptyComponent) {
  if (!emptyComponent) return null;
  var component = emptyComponent;

  if (typeof emptyComponent === 'function') {
    return component;
  }

  return (0, _preact.h)(component.type, Object.assign({}, component.props));
};

var handleFooterComponent = function handleFooterComponent(footerItem) {
  if (!footerItem) return null;
  var component = footerItem;

  if (typeof footerItem === 'function') {
    return component;
  }

  return (0, _preact.h)(component.type, Object.assign({}, component.props));
};

var handleHeaderComponent = function handleHeaderComponent(headerItem) {
  if (!headerItem) return null;
  var component = headerItem;

  if (typeof headerItem === 'function') {
    return component;
  }

  return (0, _preact.h)(component.type, Object.assign({}, component.props));
};

function FeaturedList(_ref) {
  var renderItem = _ref.renderItem,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      maxItemsToRender = _ref.maxItemsToRender,
      listHeaderComponent = _ref.listHeaderComponent,
      listFooterComponent = _ref.listFooterComponent,
      listEmptyComponent = _ref.listEmptyComponent,
      _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? {
    listContainer: 'featured-list-container',
    listTitle: 'featured-list-title',
    listWrapper: 'featured-list-wrapper'
  } : _ref$classNames;
  var Content = (0, _preact.h)(_preact.Fragment, null, data.map(function (item, index) {
    if (typeof renderItem == 'function') {
      var props = Object.assign(Object.assign({}, item), {
        eager: index == 0
      });
      return renderItem(props);
    }
  }));
  var headerComponent = handleHeaderComponent(listHeaderComponent);
  var footerComponent = handleFooterComponent(listFooterComponent);
  var emptyComponent = handleEmptyComponent(listEmptyComponent);
  return (0, _preact.h)("div", {
    className: classNames.listContainer
  }, headerComponent, data.length > 0 && (0, _preact.h)("div", {
    className: "".concat(classNames.listWrapper, " ").concat(scrollable ? 'scroll' : 'wrap')
  }, Content), !(data.length > 0) && emptyComponent, footerComponent);
}